export default "__VITE_ASSET__b5ab2df1__"